import useFetchExperimentAssignment from 'hooks/useFetchExperimentAssignment';
import {
  REORDERED_FUNNEL_CORE,
  REORDERED_FUNNEL_TEMPO,
  REORDERED_FUNNEL_FAMILY,
} from 'lib/constants/experimentConstants';

const useFunnelExperimentAssignment = (dependencies = []) => {
  const coreExperiment = useFetchExperimentAssignment(REORDERED_FUNNEL_CORE, dependencies);
  const tempoExperiment = useFetchExperimentAssignment(REORDERED_FUNNEL_TEMPO, dependencies);
  const familyExperiment = useFetchExperimentAssignment(REORDERED_FUNNEL_FAMILY, dependencies);

  const activeExperiment = [coreExperiment, tempoExperiment, familyExperiment].find(
    exp => exp?.experimentName
  );

  return activeExperiment?.experimentName
    ? { [activeExperiment.experimentName]: activeExperiment.experimentGroupSlug }
    : {};
};

export default useFunnelExperimentAssignment;
